import React from 'react';
import { useTheme } from 'react-native-paper';
import { t } from '@lingui/macro';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';

import TabItem from '@src/components/TabItem';
import { i18n } from '@src/i18n';

import ActivitiesStack from '../ActivitiesStack';
import DashboardExploreStack from '../DashboardExploreStack';
import DashboardHomeStack from '../DashboardHomeStack';
import DashboardNotificationsStack from '../DashboardNotificationsStack';
import DashboardToursStack from '../DashboardToursStack';
import { DashboardParamList } from '../types';
const ICON_SIZE = 24;
const Tab = createBottomTabNavigator<DashboardParamList>();

const Component: React.FC = () => {
  const theme = useTheme();

  return (
    <Tab.Navigator
      tabBarOptions={{
        activeTintColor: theme.colors.primary,
        labelPosition: 'below-icon',
        labelStyle: {
          fontFamily: theme.fonts.regular.fontFamily,
          fontWeight: theme.fonts.regular.fontWeight,
        },
        style: {
          borderTopColor: theme.colors.surface,
          height: 48,
          // elevation: 2,
          shadowOpacity: 0.2,
          backgroundColor: '#ffffff',
          shadowRadius: 3.84,
          shadowOffset: {
            width: 0,
            height: 1,
          },
          web: {
            elevation: 0,
            boxShadow: `${theme.colors.onBackground} 0px -0.75px 4px`,
          },
        },
      }}
    >
      <Tab.Screen
        name="HomeStack"
        component={DashboardHomeStack}
        options={{
          title: '',
          tabBarIcon: ({ color, size, focused }) =>
            focused ? (
              <TabItem
                color={theme.colors.primary}
                size={ICON_SIZE}
                source={require('@src/assets/images/home_fill.png')}
                title={`${i18n._(t`Home`)}`}
              />
            ) : (
              <TabItem
                color={theme.colors.onBackground}
                size={ICON_SIZE}
                source={require('@src/assets/images/home.png')}
                title={`${i18n._(t`Home`)}`}
              />
            ),
        }}
      />
      <Tab.Screen
        name="ActivitiesStack"
        component={ActivitiesStack}
        options={{
          title: '',
          tabBarIcon: ({ color, size, focused }) =>
            focused ? (
              <TabItem
                color={theme.colors.primary}
                size={ICON_SIZE}
                source={require('@src/assets/images/activities_fill.png')}
                title={`${i18n._(t`Activities`)}`}
              />
            ) : (
              <TabItem
                color={theme.colors.onBackground}
                size={ICON_SIZE}
                source={require('@src/assets/images/activities.png')}
                title={`${i18n._(t`Activities`)}`}
              />
            ),
        }}
      />
      <Tab.Screen
        name="ToursStack"
        component={DashboardToursStack}
        options={{
          title: '',
          tabBarIcon: ({ color, size, focused }) =>
            focused ? (
              <TabItem
                color={theme.colors.primary}
                size={ICON_SIZE}
                source={require('@src/assets/images/airplane_fill.png')}
                title={`${i18n._(t`Tours`)}`}
              />
            ) : (
              <TabItem
                color={theme.colors.onBackground}
                size={ICON_SIZE}
                source={require('@src/assets/images/airplane.png')}
                title={`${i18n._(t`Tours`)}`}
              />
            ),
        }}
      />
      <Tab.Screen
        name="ExploreStack"
        component={DashboardExploreStack}
        options={{
          title: '',
          tabBarIcon: ({ color, size, focused }) =>
            focused ? (
              <TabItem
                color={theme.colors.primary}
                size={ICON_SIZE}
                source={require('@src/assets/images/search-normal_fill.png')}
                title={`${i18n._(t`Explore`)}`}
              />
            ) : (
              <TabItem
                color={theme.colors.onBackground}
                size={ICON_SIZE}
                source={require('@src/assets/images/search-normal.png')}
                title={`${i18n._(t`Explore`)}`}
              />
            ),
        }}
      />
      <Tab.Screen
        name="NotificationsStack"
        component={DashboardNotificationsStack}
        options={{
          title: '',
          tabBarIcon: ({ color, size, focused }) =>
            focused ? (
              <TabItem
                color={theme.colors.primary}
                size={ICON_SIZE}
                source={require('@src/assets/images/notification_fill.png')}
                title={`${i18n._(t`Notifications`)}`}
              />
            ) : (
              <TabItem
                color={theme.colors.onBackground}
                size={ICON_SIZE}
                source={require('@src/assets/images/notification.png')}
                title={`${i18n._(t`Notifications`)}`}
              />
            ),
        }}
      />
    </Tab.Navigator>
  );
};
Component.displayName = 'Dashboard';

export default Component;
